module.exports = __webpack_public_path__ + "static/media/background_main11.f67d7cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_main11.png
// module id = 613
// module chunks = 0